export type Spacer = (size: number) => string

export const spacer: Spacer = size => `${size}rem`
